import { computed } from 'vue';
import useMeta from './useMeta';

export default function useMetaPageType(aMetaObj) {
  const meta = aMetaObj || useMeta();
  return computed(() => meta?.value?.pageType || {});
}
